import { DOC_TYPES } from '../types';
import type { DocTypeData } from '../types';

// Keep filters[view] for existing category links and EntityListProvider
// URL synchronization.
const VIEW_PARAMETER = 'filters[view]';

export function getCategoryPath(rootPath: string, docType: string): string {
  return `${rootPath}?${VIEW_PARAMETER}=${encodeURIComponent(docType)}`;
}

export function getDocsViewDocType(search: string): DocTypeData | undefined {
  const docType = new URLSearchParams(search).get(VIEW_PARAMETER);
  // The value comes from the URL, so a key such as `constructor` must not
  // find a member of `Object.prototype`.
  return docType && Object.hasOwn(DOC_TYPES, docType)
    ? DOC_TYPES[docType]
    : undefined;
}
